/**
 * One-shot bootstrap: fetch brand, config, idle media, and payment methods
 * immediately after auth. Cached in module memory for the session.
 * Re-fetched on tab focus (visibility change) to pick up config changes.
 */

import type { BootstrapPayload } from "./kiosk-client";
import { kioskClient } from "./kiosk-client";

let cached: BootstrapPayload | null = null;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function transform(raw: any): BootstrapPayload {
  return {
    partner_slug: raw.partner_slug ?? null,
    brand_config: raw.brand_config ?? {},
    default_language: raw.languages?.default ?? "en",
    languages: raw.languages?.allowed ?? ["en", "es", "fr-CA"],
    idle_media: raw.idle?.media ?? [],
    idle_loop_interval_seconds: raw.idle?.loop_interval_seconds ?? 8,
    idle_timeout_seconds: raw.idle?.timeout_seconds ?? 60,
    // Only expose methods whose checkout flow is implemented on the phone-side
    // checkout handler. kiosk.payments.ach and kiosk.payments.card_present
    // require separate checkout flows not yet built.
    payment_methods: (raw.payment_rails ?? []).filter(
      (r: { feature_path: string }) =>
        r.feature_path === "kiosk.payments.virtual",
    ),
  };
}

export async function fetchBootstrap(): Promise<BootstrapPayload> {
  const { data } = await kioskClient.bootstrap();
  cached = transform(data);
  return cached;
}

export function getCachedBootstrap(): BootstrapPayload | null {
  return cached;
}

export function clearBootstrapCache(): void {
  cached = null;
}
